import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, Company, Worksite, EmployeeCode } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function listExpenseAccountCode(date, jobTitle, department) {
    let url = 'expenseAccount/expenseAccountCodes?' + objectToQueryString({ company: Company(), worksite: Worksite(), userCode: UserCode(), date: date, employeeCode: EmployeeCode(), jobTitle: jobTitle, department: department, token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let expenseAccountCodes = response.expenseAccountCodes;

                //saveExpenseAccountCodes(expenseAccountCodes);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortExpenseAccountCodes(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.englishDescription.toLowerCase() : a.frenchDescription.toLowerCase()
        const nameB = IsEnglish() ? b.englishDescription.toLowerCase() : b.frenchDescription.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortExpenseAccountCodesByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.accountExpenseCode
        const nameB = b.accountExpenseCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveExpenseAccountCodes(config) {
    localStorage.setItem('expenseAccountCodes', JSON.stringify(config));
}